import { render, staticRenderFns } from "./TheFloatingButton.vue?vue&type=template&id=2fe03ae6&scoped=true&lang=pug&"
import script from "./TheFloatingButton.vue?vue&type=script&lang=js&"
export * from "./TheFloatingButton.vue?vue&type=script&lang=js&"
import style0 from "./TheFloatingButton.vue?vue&type=style&index=0&id=2fe03ae6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe03ae6",
  null
  
)

export default component.exports